<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" :title="'SLA Bimbingan ' + title" @back="back">
            <common-training-header :withUser="false"/>
        </a-page-header>

        <a-card type="inner" size="small">
            <a-table
                class="pcp-table"
                :dataSource="items.user_guidance"
                rowKey="hash"
                :pagination="false"
                :loading="loading"
                bordered>

                <a-table-column key="title" title="Nama" className="align-center text-small text-left">
                    <template slot-scope="record">
                        {{ record.name }}
                    </template>
                </a-table-column>

                <template v-for="(item, index) in items.outline">
                    <a-table-column-group :key="item.hash" >
                        <span slot="title">{{ item.title }}</span>

                        <a-table-column :key="'upload_time'+index" title="Waktu Upload" className="align-center text-small text-center">
                            <template slot-scope="record">
                                <div v-if="!emptyOutlines(record.activities[0].outlines)">
                                    {{ hasProperty(record.activities, item.title).first_upload_time }}
                                </div>
                            </template>
                        </a-table-column>

                        <a-table-column :key="'upload_approval'+index" title="Waktu Approval" className="align-center text-small text-center">
                            <template slot-scope="record">
                                <div v-if="!emptyOutlines(record.activities[0].outlines)">
                                    {{ hasProperty(record.activities, item.title).approval_time }}
                                </div>
                            </template>
                        </a-table-column>

                        <a-table-column :key="'sla'+index" title="SLA" className="align-center text-small text-center">
                            <template slot-scope="record">
                                <div v-if="!emptyOutlines(record.activities[0].outlines)">
                                    <a-button size="small" @click="detail(hasProperty(record.activities, item.title).outline_hash, getActivity(record.activities, item.title))" style="font-size:11px">
                                        {{ hasProperty(record.activities, item.title).diff_in_days }}
                                    </a-button>
                                </div>
                            </template>
                        </a-table-column>
                    </a-table-column-group>
                </template>

                

            </a-table>
        </a-card>
    </div>
</template>

<script>
export default {
    props: {
        module: {
            type: String,
            default: 'paper'
        }
    },
    data() {
        return {
            items: {},
            loading: false,
            processing: false,
        }
    },
    created() {
        this.getItems()
    },
    computed: {
        activeModule() {
            return this.$laravel.active_module
        },
        title(){
            switch(this.module) {
                case "project":
                    return "Project Management"
                default:
                    return "Makalah"
            }
        }
    },
    methods: {
        getItems() {
            this.loading = true;

            let params = this.module == 'paper' ? 'paper' : 'project'

            this.$http
                .get(this.routeUri("api.report.sla.guidance", {report_module: params}))
                .then(response => this.items = response.data)
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        emptyOutlines(outlines){
            return outlines instanceof Array ? true : false
        },
        hasProperty(activities, title){
            let outline = {}

            activities.forEach(function (item, index) {
                if(item.outlines.hasOwnProperty(title)){
                    outline = item.outlines[title]
                }
            })
            
            return outline
        },
        getActivity(activities, title){
            let activity = ""

            activities.forEach(function (item, index) {
                if(item.outlines.hasOwnProperty(title)){
                    activity = item.id
                }
            })
            
            return activity
        },
        back() {
            window.location.href = this.routeUri('admin.classical.general.report')
        },
        detail(outline, activity){
            let params = {
                outline: outline,
                activity: activity
            }

            window.location.href = this.routeUri('admin.paper.sla.detail') + '?' + this.$qs.stringify(params)
        }
    }
}
</script>